import { render } from "./SubjectList.vue?vue&type=template&id=5bd03a93&ts=true&lang=pug"
import script from "./SubjectList.vue?vue&type=script&lang=ts"
export * from "./SubjectList.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/edtechqc/front-end/next-front/eduqc-front-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerOrbit from 'quasar/src/components/spinner/QSpinnerOrbit.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QScrollArea,QInnerLoading,QSpinnerOrbit});qInstall(script, 'directives', {Ripple});
